import graphql__9520024e9d0a434d4266 from "./__generated__/ComplexMenuDesktopVerticalSubmenu_navigationItem.graphql.js";import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import ComplexMenuDesktopVerticalSubmenuItem from "./ComplexMenuDesktopVerticalSubmenuItem";

const ComplexMenuDesktopVerticalSubmenu = forwardRef((props, ref) => {
  const navigationItem = useFragment(
    ComplexMenuDesktopVerticalSubmenu_navigationItem,
    props.navigationItem
  );

  const { children = [] } = navigationItem;
  const { onMouseEnter, onMouseLeave, className } = props;

  const containerClassName = classNames(
    "complex-menu-vertical-submenu-container",
    "position-absolute",
    "bg-white",
    "box-shadow",
    className
  );

  if (!children.length) return null;

  return (
    <div
      ref={ref}
      className={containerClassName}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <ul className="complex-menu-vertical-submenu list-unstyled padding-none margin-bottom-none">
        {children.map(child => (
          <ComplexMenuDesktopVerticalSubmenuItem key={child.id} navigationItem={child} />
        ))}
      </ul>
    </div>
  );
});

ComplexMenuDesktopVerticalSubmenu.displayName = "ComplexMenuDesktopVerticalSubmenu";

const ComplexMenuDesktopVerticalSubmenu_navigationItem = graphql__9520024e9d0a434d4266;

export default ComplexMenuDesktopVerticalSubmenu;
